/**Dependencies */
import { Routes, Route, useLocation } from "react-router-dom";

/**Views */
import { Home } from "./views/Home";
import { Hotels } from "./views/Hotels";
/* import { Tours } from "./views/Tours"; */
import { Experiencias } from "./views/Experiencias";
import { ExperienciasResultado } from "./views/ExperienciasResultado";
import { Circuitos } from "./views/Circuitos";
import { Alojamientos } from "./views/Alojamientos";
import { InfoHotel } from "./views/InfoHotel";
import { InfoExperiencia } from "./views/InfoExperiencia";
import { BusquedaActividades } from "./views/BusquedaActividades";
import { FichaTours } from "./views/FichaTours";
import { Traslados } from "./views/Traslados";
import { RentaAutos } from "./views/RentaAutos";
import { Colecciones } from "./views/Colecciones";
import { Terminos } from "./views/Terminos";
import { PoliticaCookies } from "./views/PoliticaCookies";
import { PoliticaPrivacidad } from "./views/PoliticaPrivacidad";
import { PreguntaFrecuentes } from "./views/PreguntaFrecuentes";
import { Nosotros } from "./views/Nosotros";

/**Styles */
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "lightbox2/dist/css/lightbox.min.css"; // Importamos los estilos de lightbox.js

/**Components */
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { ScrollToTop } from "./components/ScrollToTop";
import { Preventa } from "./views/Preventa";
import { Checkout } from "./views/CheckOut";
import { ConfirmReserva } from "./views/ConfirmReserva";
import { Signup } from "./views/Signup";
import { Login } from "./views/Login";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ResetPassword } from "./views/ResetPassword";
import { ReSendEmailPassword } from "./views/ReSendEmailPassword";
import { ScrollToTopRoute } from "./components/ScrollToTopRoute";

function App() {
  const location = useLocation();
  return (
    <div className="App">
      {location.pathname !== "/reserva/confirmada" &&
        location.pathname !== "/login" &&
        location.pathname !== "/signup" &&
        location.pathname !== "/resend-email" &&
        location.pathname !== "/restablecer-contrasena" && <Header />}
      <ScrollToTopRoute />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hoteles" element={<Hotels />} />
        <Route path="/experiencias" element={<Experiencias />} />
        <Route
          path="/experiencias-resultado"
          element={<ExperienciasResultado />}
        />
        {/* <Route path="" element={ <Tours /> } /> */}
        <Route path="/circuitos" element={<Circuitos />} />
        <Route path="/colecciones" element={<Colecciones />} />
        <Route path="/alojamientos" element={<Alojamientos />} />
        <Route path="/info-hotel" element={<InfoHotel />} />
        <Route path="/info-experiencia" element={<InfoExperiencia />} />
        <Route path="/preventa" element={<Preventa />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/reserva/confirmada" element={<ConfirmReserva />} />
        <Route path="" element={<BusquedaActividades />} />
        <Route path="" element={<FichaTours />} />
        <Route path="/traslados" element={<Traslados />} />
        <Route path="/renta-autos" element={<RentaAutos />} />
        <Route path="/terminos-y-condiciones" element={<Terminos />} />
        <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
        <Route
          path="/politica-de-privacidad"
          element={<PoliticaPrivacidad />}
        />
        <Route path="/preguntas-frecuentes" element={<PreguntaFrecuentes />} />
        <Route path="/nosotros" element={<Nosotros />} />
        {/* Login - Signup */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/restablecer-contrasena" element={<ResetPassword />} />
        <Route path="/resend-email" element={<ReSendEmailPassword />} />
      </Routes>
      <WhatsAppFloat />
      <ScrollToTop />
      {location.pathname !== "/reserva/confirmada" &&
        location.pathname !== "/login" &&
        location.pathname !== "/signup" &&
        location.pathname !== "/resend-email" &&
        location.pathname !== "/restablecer-contrasena" && <Footer />}
    </div>
  );
}

export default App;
